import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../mentorsList/MentorsList.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function ExpertsList() {
    const [experts, setExperts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOption, setSortOption] = useState("name");
    const [searchParams] = useSearchParams();
    const category = searchParams.get("category");
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch experts from the backend
        const fetchExperts = async () => {
            try {
                const url = category
                    ? `${BASE_URL}/expert/getExpertsDetails.php?category=${category}`
                    : `${BASE_URL}/expert/getExpertsDetails.php`;
                const response = await fetch(url);
                const data = await response.json();
                const filteredExperts = data.filter(expert => expert.isApproved);
                setExperts(filteredExperts);
            } catch (error) {
                console.error("Error fetching experts:", error);
            }
        };
        fetchExperts();
    }, [category]);

    const filteredExperts = experts
        .filter((expert) =>
            `${expert.name} ${expert.experience} ${expert.category}`.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => {
            if (sortOption === "category") return b.category.localeCompare(a.category);
            if (sortOption === "rating") return b.rating - a.rating;
            return 0;
        });

    const handleBookClick = (expertId) => {
        navigate(`/professional-profile/${expertId}`); // Navigate to ExpertDetails page
    };

    return (
        <div className="coaches-list-container">
            <div className="coaches-header">
                <input
                    type="text"
                    className="coaches-search-bar"
                    placeholder="Search Experts..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div>
                    <p className="sort-by-text">Sort by</p>
                    <select
                        className="coaches-sorting-dropdown"
                        value={sortOption}
                        onChange={(e) => setSortOption(e.target.value)}
                    >
                        <option value="category">Category</option>
                        <option value="rating">Rating</option>
                    </select>
                </div>
            </div>
            <div className="coaches-list">
                {filteredExperts.map((expert) => (
                    <div key={expert.expertId} className="coach-card">
                        <img
                            src={`${BASE_URL}/images/profile/${expert.profileImageName}`}
                            alt={expert.name}
                            className="coach-image"
                        />
                        <div className="coach-info">
                            <h3 className="coach-name">{expert.name}</h3>
                            <p className="coach-experience">
                                {expert.experience} years of experience
                            </p>
                            <p className="coach-category">{expert.category}</p>
                            <p className="coach-approval">
                                {expert.isApproved ? "Approved" : "Pending Approval"}
                            </p>
                            <p className="coach-category">
                                ⭐{expert.rating.toFixed(1)}
                            </p>
                        </div>
                        <button
                            className="coach-book-button"
                            onClick={() => handleBookClick(expert.expertId)}
                        >
                            Book</button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ExpertsList;
